import React, { useCallback, useEffect, useState } from 'react';

import { InfoCircleTwoTone } from '@ant-design/icons';

import { Modal, Button, Input } from 'antd';

import { ConvTagType } from '../conv-tag';

import MyTag from '../my-tag';

import styles from './index.less';

export interface SummaryInfoType {
  tags: ConvTagType[];
  summary: string;
}

interface IProps {
  visible: boolean;
  info: any;
  changeConvTags: (tags: number[]) => void;
  changeConvSummary: (summary: string) => void;
  onClose: () => void;
}

const convSummaryModal: React.FC<IProps> = ({ visible, info, changeConvTags, onClose, changeConvSummary }) => {

  const { summary = '', tags = [] } = info || {};

  const [selectedConvTags, setSelectedConvTags] = useState<any[]>([]);

  const [summaryContent, setSummaryContent] = useState<string>('');

  const deleteTag = (tag: any) => {
    const { id } = tag;

    const newTags = selectedConvTags.filter((val: ConvTagType) => val.id !== id);
    setSelectedConvTags(newTags);
  };

  const handleChangeContent = (e: any) => {
    const { value } = e.target;
    setSummaryContent(value);
  };

  const handleApplyTags = useCallback(() => {
    const newTags = selectedConvTags.map(val => val.id) || [];

    changeConvTags(newTags);
  }, [selectedConvTags]);

  const handleApplySummary = useCallback(() => {
    changeConvSummary(summaryContent);
  }, [summaryContent]);

  useEffect(() => {
    if (visible) {
      setSelectedConvTags(tags);
      setSummaryContent(summary);
    } else {
      setSelectedConvTags([]);
      setSummaryContent('');
    }
  }, [visible]);

  return (
    <Modal
      open={visible}
      footer={null}
      title={'系统生成对话总结'}
      width={600}
      wrapClassName={styles.modal}
      onCancel={onClose}
    >
      <div className={styles.desc}>
        <div className={styles.desc_title}>
          <InfoCircleTwoTone />
          <span className={styles.desc_title_desc}>{'说明'}</span>
        </div>
        <div className={styles.desc_content}>
          {'系统生成最合适的 5 个对话标签，以及该段对话的对话小结，系统生成内容仅供参考'}
        </div>
      </div>
      <div className={styles.block}>
        <div className={styles.block_title}>{'对话标签'}</div>
        <div className={styles.tags}>
          {selectedConvTags.map(val => {
            const { tag_name, id, color } = val;
            return (
              <MyTag
                label={tag_name}
                closable={true}
                key={id}
                color={color === '' ? 'tag-blue' : color}
                onClose={() => deleteTag(val)}
              />
            );
          })}
        </div>
        <Button type='primary' size='small' onClick={handleApplyTags}>
          {'应用'}
        </Button>
      </div>
      <div className={styles.block}>
        <div className={styles.block_title}>{'对话小结'}</div>
        <Input.TextArea
          value={summaryContent}
          placeholder={'请输入'}
          autoSize={{ minRows: 2, maxRows: 6 }}
          onChange={handleChangeContent}
          maxLength={200}
        />
        <Button type='primary' size='small' onClick={handleApplySummary}>
          {'应用'}
        </Button>
      </div>
    </Modal>
  );
};

export default convSummaryModal;
